import { computed } from 'vue'
import { useRouter } from 'vue-router'
import { useAuthStore } from '@/stores/auth'
import { canAccessRoute } from '@/router/access'

/**
 * El menú, generado a partir de las rutas.
 *
 * Antes era una lista de 18 <v-list-item> escritos a mano en el layout, con sus
 * etiquetas, iconos y permisos duplicados respecto al router (y, en tres casos,
 * distintos). Ahora una ruta con `meta.nav` sale en el menú y una sin ella no,
 * y quién la ve lo decide la misma función que el guard.
 *
 * Las secciones vacías no se pintan, así que desaparecen también los separadores
 * sueltos que quedaban colgando según los permisos del usuario.
 */
const SECTIONS = [
  { id: 'main', labelKey: null },
  { id: 'library', labelKey: 'nav.section_library' },
  { id: 'discover', labelKey: 'nav.section_discover' },
  { id: 'admin', labelKey: 'nav.section_admin' },
]

export function useNavigation() {
  const router = useRouter()
  const auth = useAuthStore()

  const sections = computed(() => {
    const items = router
      .getRoutes()
      .filter((route) => route.meta?.nav && canAccessRoute(route, auth))
      .map((route) => ({
        name: route.name,
        to: { name: route.name },
        labelKey: route.meta.nav.labelKey,
        icon: route.meta.nav.icon,
        section: route.meta.nav.section,
        order: route.meta.nav.order ?? 100,
      }))

    return SECTIONS.map((section) => ({
      ...section,
      items: items.filter((item) => item.section === section.id).sort((a, b) => a.order - b.order),
    })).filter((section) => section.items.length > 0)
  })

  return { sections }
}
